import { Configuration, LogLevel } from "@azure/msal-browser";

// MSAL configuration as per Azure best practices
export const msalConfig: Configuration = {
  auth: {
    clientId: "a0f3fad1-65f7-48fa-be4a-e93df9d033ad",
    authority: "https://login.microsoftonline.com/2b0cb2a3-3262-4e5e-b6ab-a26e7847d88e",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true, // Azure best practice for handling redirects
  },
  cache: {
    cacheLocation: "sessionStorage", 
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            return;
          case 1: // Warning
            console.warn(message);
            return;
          case 2: // Info
            console.info(message);
            return;
          case 3: // Verbose
            console.debug(message);
            return;
        }
      },
      logLevel: 2, // Set to info level as per Azure guidelines
    }
  }
};

// Application scopes - updated with SharePoint Embedded scopes
export const loginRequest = {
  scopes: [
    "openid", 
    "profile", 
    "offline_access",
    "User.Read", 
    "Files.ReadWrite.All", 
    "Sites.FullControl.All",  // Required for SharePoint Embedded container management
    "FileStorageContainer.Selected"
  ]
};

// Add endpoints here for Microsoft Graph API services
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphStorageEndpoint: "https://graph.microsoft.com/v1.0/storage/fileStorage/containers"
};
